import { Element, Node } from "@siteimprove/alfa-dom";
import { Style } from "../../style.js";
const { isElement } = Element;
/**
 * @public
 */
export function hasUsedStyle(name, predicate, device, context) {
    return function hasUsedStyle(node) {
        return isElement(node)
            ? Style.from(node, device, context)
                .used(name)
                .some((used) => used.some(predicate))
            : node.parent(Node.flatTree).filter(isElement).some(hasUsedStyle);
    };
}
//# sourceMappingURL=has-used-style.js.map